import { render, staticRenderFns } from "./projectsAll.vue?vue&type=template&id=3297f9e0&scoped=true&"
import script from "./projectsAll.vue?vue&type=script&lang=js&"
export * from "./projectsAll.vue?vue&type=script&lang=js&"
import style0 from "./projectsAll.vue?vue&type=style&index=0&id=3297f9e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3297f9e0",
  null
  
)

export default component.exports